<template>
  <div class="fff">
    <div class="timeAll_w">
      <el-date-picker
        v-model="value1"
        class="timeAll"
        type="daterange"
        @change="getlist"
        range-separator="-"
        disabled
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-dropdown disabled @command="handleCommand" class="timeDow">
        <span
          class="el-dropdown-link"
          :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
        >
          {{ $t("Last days Days", { days: days })
          }}<i
            class="el-icon-caret-bottom el-icon--right"
            :style="{ color: !isChecked ? '#606266' : '#00eec3' }"
          ></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="7">{{
            $t("events.num1")
          }}</el-dropdown-item>
          <el-dropdown-item command="30">{{
            $t("events.num2")
          }}</el-dropdown-item>
          <el-dropdown-item command="60">{{
            $t("events.num3")
          }}</el-dropdown-item>
          <el-dropdown-item command="90">{{
            $t("events.num4")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <table class="mytable">
      <tr>
        <th>{{ $t("events.title") }}</th>
        <th>{{ $t("events.description") }}</th>
        <th>{{ $t("events.location") }}</th>
        <th style="min-width: 150px">{{ $t("events.started") }}</th>
        <th style="min-width: 150px">{{ $t("events.completed") }}</th>
      </tr>
      <tr v-for="(val, key) in list" :key="key">
        <td>
          <el-popover
            placement="bottom"
            title=""
            width="600"
            trigger="click"
            :content="val.title"
          >
            <span slot="reference" class="txt">{{ val.title }}</span>
          </el-popover>
        </td>
        <td>
          <el-popover
            placement="bottom"
            title=""
            width="600"
            trigger="click"
            :content="val.miaoshu"
          >
            <span slot="reference" class="txt">{{ val.miaoshu }}</span>
          </el-popover>
        </td>
        <td>
          <el-popover
            placement="bottom"
            title=""
            width="600"
            trigger="click"
            :content="val.address"
          >
            <span slot="reference" class="txt">{{ val.address }}</span>
          </el-popover>
        </td>
        <td style="min-width: 150px">{{ val.starttime }}</td>
        <td style="min-width: 150px">{{ val.endtime }}</td>
      </tr>
      <!-- <tr>
      <td>Matty'sbirthday</td>
      <td>Order a present for Matt</td>
      <td>316 N Washington St,Watertown, WI, 54801</td>
      <td>Apr 5, 2021 7:20 AM</td>
      <td>Apr 5, 2021 7:20 AM</td>
    </tr> -->
    </table>
    <div class="noData" v-if="list.length <= 0 && status">
      {{ $t("events.no") }}
    </div>
    <div class="pagination" v-if="code > 0">
      <el-pagination
        @current-change="setPage"
        background
        layout="prev, pager, next"
        :total="code"
        page-size="20"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { Event } from "@/api/user";

export default {
  name: "HelloWorld",
  data() {
    return {
      days: 7,
      key: {
        equipment_id: localStorage.getItem("systemId"),
        page: 1,
        limit: 20,
        starttime: "",
        endtime: "",
      },
      code: 0,
      value1: "", // 获取时间
      list: [],
      msg: "",
      isChecked: null,
      status: false,
    };
  },
  mounted() {
    this.handleCommand();
  },
  methods: {
    handleCommand(event) {
      // let end = new Date()
      let start = new Date(2021, 0, 1);
      let end = new Date(2022, 3, 30);
      if (event) {
        this.days = event;
        start = new Date();
        this.isChecked = true;
        start.setTime(start.getTime() - 3600 * 1000 * 24 * event);
      }
      this.value1 = [start, end];
      console.log(this.value1);
      this.getlist();
    },
    setPage(e) {
      this.key.page = e;
      this.getlist();
    },
    getlist(a) {
      this.status = false;
      this.key.starttime =
        this.value1[0].getFullYear() +
        "-" +
        (this.value1[0].getMonth() < 9 ? "0" : "") +
        (this.value1[0].getMonth() + 1) +
        "-" +
        (this.value1[0].getDate() < 10 ? "0" : "") +
        this.value1[0].getDate();
      this.key.endtime =
        this.value1[1].getFullYear() +
        "-" +
        (this.value1[1].getMonth() < 9 ? "0" : "") +
        (this.value1[1].getMonth() + 1) +
        "-" +
        (this.value1[1].getDate() < 10 ? "0" : "") +
        this.value1[1].getDate();
      console.log(this.key);
      if (a) {
        this.key.page = a;
      }
      this.list = [];
      Event(this.key).then((adj) => {
        this.list = adj.data.list;
        this.code = adj.data.count;
        this.status = true;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fff {
  width: 97%;
  margin: 20px auto;
  background: #fff;
  border-radius: 12px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.2);
  overflow: hidden;
}
.pop_ul {
  float: left;
  /* width: 385px; */
  width: 419px;
  border-right: 1px solid #e1e3e6;
  background: #fff;
  right: 0;
}
#app >>> .el-popover {
  background: #fff;
}

.txt {
  display: inline-block;
  max-width: 100%;
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.eventTable {
  overflow-x: auto;
}
.eventTable tr {
  text-indent: 0px;
}
@media screen and (max-width: 1400px) {
  .txt {
  display: inline-block;
  max-width: 200px;
  width: auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Events.vue